import { motion } from "framer-motion";
import { WhatsappLogo } from "@phosphor-icons/react";
import { buildWhatsAppLink } from "@/data/services";

export const FloatingWhatsApp = () => {
  const link = buildWhatsAppLink(
    "Hi RapidRescue, I need roadside help. My details:\nName:\nVehicle:\nLocation:\nProblem:"
  );

  return (
    <motion.a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Chat with us on WhatsApp"
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.4, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.92 }}
      className="fixed bottom-6 right-6 z-50 group flex items-center gap-3"
    >
      <span className="hidden sm:block bg-rescue-surface border border-white/10 text-white text-sm font-semibold px-4 py-2 rounded-sm shadow-lg opacity-0 group-hover:opacity-100 transition-opacity">
        Chat on WhatsApp
      </span>
      <span className="relative grid place-items-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.45)]">
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" />
        <WhatsappLogo weight="fill" size={30} className="relative z-10" />
      </span>
    </motion.a>
  );
};
